// Centralized INR currency formatter for the frontend
export const formatINR = (amount) => {
  const numeric = Number(amount || 0);
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(numeric);
  } catch (e) {
    // Fallback
    return `₹${numeric.toFixed(2)}`;
  }
};

export default formatINR;


